{
    "WebexAuth_UserIntro": "CIAO **{}**,",
    "WebexAuth_UserIntro_2": "CX Analytics richiede l'accesso al tenant Webex Calling",
    "WebexAuth_AdminConsent": "Concedi il consenso dell'amministratore",
    "WebexAuth_Authorise": "Autorizzare",
    "WebexAuth_ConsentedMessage": "Consenso dell'amministratore concesso, fare clic su Autorizza per continuare",
    "WebexAuth_AuthorisedMessage": "Autorizzazione concessa",
    "WebexAuth_Decline": "Declino",
    "WebexAuth_Error_Unknown": "Si è verificato un errore sconosciuto. Riprova. Se il problema persiste, contatta l'amministratore di sistema.",
    "NAME": "WebexAuthLanguage"
}